export const ActionTypes = {
  FETCH_ALL: 'services/factory/fetch_all',
  FETCH_ALL_SUCCESS: 'services/factory/fetch_all_success',
  SET_LOADER_STATUS: 'services/factory/set_loader_status',
  SET_ALL: 'services/factory/set_all',
  ADD_OR_UPDATE_FACTORY: 'services/factory/add_or_update_factory',
  DELETE_FACTORY: 'services/factory/delete_factory',
};

const fetchAll = ({ factoryParams }) => ({
  factoryParams,
  type: ActionTypes.FETCH_ALL,
});

const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

const setAll = ({ allFactory }) => ({
  allFactory,
  type: ActionTypes.SET_ALL,
});

const addorUpdateFactory = ({ factoryData, actionName, factoryParams }) => ({
  factoryData,
  actionName,
  factoryParams,
  type: ActionTypes.ADD_OR_UPDATE_FACTORY,
});

const deleteFactory = ({ id, factoryParams }) => ({
  id,
  factoryParams,
  type: ActionTypes.DELETE_FACTORY,
});

export default {
  fetchAll,
  setAll,
  setLoader,
  addorUpdateFactory,
  deleteFactory,
};
